const $ = jQuery.noConflict();
'use strict';

const InquiryFormProducts = {
	quantity: [],
	tempQuantity: [],
	debounceTimers: {},

	init: function() {
		const _this = this;
		$(document).ready(function() {
			_this.setInitialState();
			_this.addEvents();
			_this.addModalOpenerListener();
			_this.updateHiddenProductsField();
		});
	},

	addModalOpenerListener: function() {
		const _this = this;
		$('.js-product-tile-popup-trigger').on('click', function() {
			const parent = $(this).closest('.js-tile-main');
			const productSku = parent?.data('product_sku');
			if (productSku) {
				_this.showModal(productSku, false);
				_this.addRemoveFromCartListener();
			}
		});
	},

	setInitialState: function() {
		const _this = this;
		$('.js-quantity').each(function() {
			const currentQuantity = parseInt($(this).html());
			const parent = $(this).closest('.js-tile-main');
			if (parent) {
				const productSku = $(parent).data('product_sku');
				_this.quantity[productSku] = currentQuantity;
			}
		});
	},

	updateDecreaseIcon: function(decreaseBtn, quantity) {
		decreaseBtn.toggleClass('is-trash', quantity <= 1);
	},

	addEvents: function() {
		const _this = this;
		$('.js-summary-increase, .js-summary-decrease').each(function() {
			const clickedButton = $(this);
			clickedButton.off('click').on('click', function() {
				const parent = $(clickedButton).closest('.js-tile-main');
				const loader = clickedButton.parent().find('.js-loader-button');
				const productSku = parent?.data('product_sku');
				const quantityElement = parent.find('.js-quantity').first();

				if (!productSku) return;

				const isDecrease = clickedButton.hasClass('js-summary-decrease');
				const currentQty = _this.tempQuantity[productSku] !== undefined
					? _this.tempQuantity[productSku]
					: _this.quantity[productSku];

				if (isDecrease && currentQty <= 1) {
					parent.find('.js-product-tile-popup-trigger').first().trigger('click');
					return;
				}

				if (_this.tempQuantity[productSku] === undefined) {
					_this.tempQuantity[productSku] = parseInt(quantityElement.html()) || 0;
				}

				if (clickedButton.hasClass('js-summary-increase')) {
					_this.tempQuantity[productSku]++;
				} else if (_this.tempQuantity[productSku] > 0) {
					_this.tempQuantity[productSku]--;
				}

				if (quantityElement) {
					quantityElement.html(_this.tempQuantity[productSku].toString());
				}

				_this.updateDecreaseIcon(parent.find('.js-summary-decrease').first(), _this.tempQuantity[productSku]);

				if (_this.debounceTimers[productSku]) {
					clearTimeout(_this.debounceTimers[productSku]); // Clear only the timer for this product
				}

				if (_this.tempQuantity[productSku] === 0) {
					_this.showModal(productSku, true);
					const quantityElement = parent.find('.js-quantity').first();
					if (quantityElement) {
						setTimeout(function() {
							quantityElement.html(_this.quantity[productSku].toString());
						}, 500);
					}
				} else {
					_this.debounceTimers[productSku] = setTimeout(function() {
						const quantitySnapshot = _this.tempQuantity[productSku];
						delete _this.debounceTimers[productSku];
						if (quantitySnapshot === undefined) return;

						$.ajax({
							type: 'POST',
							url: window.fwsLocalized.ajaxUrl,
							data: {
								action: 'update-cart-by-product-sku',
								productSku: productSku,
								quantity: quantitySnapshot,
							},
							beforeSend: function() {
								if (loader) {
									loader.addClass('is-active');
								}
							},
							success: function(response) {
								if (response.success) {
									_this.quantity[productSku] = quantitySnapshot;
									const element = clickedButton.parent().find('.js-quantity').first();
									element.html(quantitySnapshot.toString());
									if (response?.data?.cart_count !== undefined && response?.data?.cart_count !== null) {
										_this.updateCartTotalText(response.data.cart_count);
									}
									_this.updateHiddenProductsField();
								}
							},
							complete: function() {
								if (loader) {
									loader.removeClass('is-active');
								}
								if (_this.tempQuantity[productSku] === quantitySnapshot) {
									delete _this.tempQuantity[productSku];
								}
							},
						});
					}, 1000);
				}
			});
		});
	},

	updateCartTotalText: function(newTotal) {
		const totalCounter = $('.js-nav-cart-sum');
		totalCounter.text(newTotal);
		if (newTotal > 0) {
			totalCounter.removeClass('hidden-element');
		} else {
			totalCounter.addClass('hidden-element');
		}
	},

	showModal: function(productSku, triggerEvent) {
		const _this = this;
		const productContainer = $('.js-tile-main[data-product_sku="' + productSku + '"]');
		if (productContainer) {
			const imageHtml = $(productContainer).find('.js-product-image');
			const infoHtml = $(productContainer).find('.js-product-info');
			const popupContainer = $('.js-product-tile-popup-info');
			popupContainer.html('');
			if (imageHtml && infoHtml) {
				popupContainer.append(
					$(imageHtml).clone(),
					$(infoHtml).clone(),
				);

				const removeItemButton = $('.js-remove-item');
				if (removeItemButton) {
					removeItemButton.attr('data-product_sku', productSku);
					removeItemButton.data('product_sku', productSku);
				}

				if (triggerEvent) {
					const productTrigger = productContainer.find('.js-product-tile-popup-trigger').first();
					if (productTrigger) {
						productTrigger.click();
					}
				}
			}

			$('.js-cancel-removal').off('click').on('click', function() {
				const quantityElement = productContainer.find('.js-quantity').first();
				const pending = _this.tempQuantity[productSku];
				if (pending !== undefined && pending > 0) {
					// Came from trash click with a pending quantity change — keep it
					// and let the debounce AJAX commit it naturally.
					quantityElement.html(pending.toString());
					_this.updateDecreaseIcon(productContainer.find('.js-summary-decrease').first(), pending);
				} else {
					// No pending change (X button) or quantity reached 0 — restore committed value.
					const restoredQty = _this.quantity[productSku] !== undefined
						? _this.quantity[productSku]
						: parseInt(quantityElement.html()) || 0;
					quantityElement.html(restoredQty.toString());
					_this.updateDecreaseIcon(productContainer.find('.js-summary-decrease').first(), restoredQty);
					delete _this.tempQuantity[productSku];
				}
			});
		}
	},

	addRemoveFromCartListener: function() {
		const _this = this;
		$('.js-remove-item').off('click').on('click', function() {
			const productSku = $(this).data('product_sku');
			if (!productSku) return;

			const loader = $(this).find('.js-remove-btn-loader');

			$.ajax({
				type: 'POST',
				url: window.fwsLocalized.ajaxUrl,
				data: {
					action: 'update-cart-by-product-sku',
					productSku: productSku,
					quantity: 0,
				},
				beforeSend: function() {
					if (loader) {
						loader.addClass('is-active');
					}
				},
				success: function(response) {
					if (response.success) {
						const productContainer = $('.js-tile-main[data-product_sku="' + productSku + '"]');
						if (productContainer) {
							productContainer.remove();
							const summaryCount = $('.js-summary-count');
							if (summaryCount) {
								const count = parseInt(summaryCount.data('count'));
								const newCount = count - 1;
								if (newCount === 1) {
									summaryCount.html('(1 item)');
								} else {
									summaryCount.html('(' + newCount + ' Items)');
								}
								summaryCount.data('count', newCount);
							}
						}
						if (response?.data?.cart_count !== undefined && response?.data?.cart_count !== null) {
							_this.updateCartTotalText(response.data.cart_count);
						}
						$.fancybox.close();
						_this.updateHiddenProductsField();

						if (response?.data?.cart_count === 0 || $('.inquiry__items .js-tile-main').length === 0) {
							window.location.href = window.location.pathname + window.location.search;
						}
					}
				},
				complete: function() {
					if (loader) {
						loader.removeClass('is-active');
					}
				},
			});
		});
	},

	updateHiddenProductsField() {
		const products = [];
		$('.inquiry__items .js-tile-main').each(function(){
			const sku = $(this).data('product_sku');
			const qty = $(this).find('.js-quantity').text().trim();
			products.push(sku + ' x' + Number(qty));
		});
		$('#quote-request-form [name=products]').val(products.join("\n")); // eslint-disable-line quotes
	},

};

export default InquiryFormProducts;
